<!-- kendo-checkbox-group component -->
<div class="kendo-checkbox-group">
    <div class="kendo-checkbox" *ngFor="let option of options; let i = index">
        <kendo-label
            class="k-checkbox-label"
            [text]="option.name"
        ></kendo-label>
        <input type="checkbox" kendoCheckBox (click)="onClick(option)"/>
    </div>
</div>